import { RouteObject } from "../../interfaces/navigation";
import EntryPoint from "../../containers/Leads/EntryPointContainer";
import BrandLeadsEntryPoint from "../../containers/Leads/BrandLeadsEntryPointContainer";
import Publication from "../../containers/Publication/EntryPointContainer";
import ReportsEntryPoint from "../../containers/Leads/ReportsEntryPointContainer";
import TermsConditionReport from "../../containers/Settings/TermsConditionReport/EntryPointContainer";
import LinzeSalesReport from "../../containers/Leads/LinzeSalesReportContainer";

export const leadsSubRoutes: RouteObject[] = [
    {
        title: "Gestión",
        path: ":id/management",
        component: <Publication/>
    }
];

export const leadsRoutes: RouteObject[] = [
    {
        title: "Reportes",
        path: "leads-reports",
        component: <ReportsEntryPoint/>,
        subRoutes: leadsSubRoutes
    },
    {
        title: "Reporte TyC",
        path: "tyc-report",
        component: <TermsConditionReport/>,
        protected: true
    },
    {
        title: "Ventas Linze",
        path: "ventas-linze-report",
        component: <LinzeSalesReport/>,
        protected: true
    },
    {
        title: "Leads Concesionarios",
        path: "leads",
        component: <EntryPoint/>,
        subRoutes: leadsSubRoutes
    },
    {
        title: "Leads Marcas",
        path: "leads-marcas",
        component: <BrandLeadsEntryPoint/>,
        subRoutes: leadsSubRoutes
    }
];